import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        notification: 0
    },
    getters: {
        notification: state => {
            return state.notification;
        }
    },
    mutations: {
        updateNotification: (state, payload) => {
            state.notification = payload;
        }
    },
    actions: {
        updateNotification: ({ commit }, payload) => {
            commit('updateNotification', payload);
            localStorage.setItem('notification', payload);
        }
    }
});


// WEBPACK FOOTER //
// ./src/store/store.js